import { useState } from 'react';
//import styles from './DPad.module.css';
// REPLACE WITH:
import styles from '../../Assets/Styles/Joystick/DPad.module.css';

const DIRS = [
  { key: 'F', cls: 'up',
    icon: <svg viewBox="0 0 20 20" width="20" height="20"><path d="M10 4 17 14H3Z" fill="currentColor"/></svg> },
  { key: 'L', cls: 'left',
    icon: <svg viewBox="0 0 20 20" width="20" height="20"><path d="M4 10 14 3v14Z" fill="currentColor"/></svg> },
  { key: 'S', cls: 'center', icon: <span>STOP</span> },
  { key: 'R', cls: 'right',
    icon: <svg viewBox="0 0 20 20" width="20" height="20"><path d="M16 10 6 3v14Z" fill="currentColor"/></svg> },
  { key: 'B', cls: 'down',
    icon: <svg viewBox="0 0 20 20" width="20" height="20"><path d="M10 16 3 6h14Z" fill="currentColor"/></svg> },
];

export default function DPad({ onPress, onRelease }) {
  const [held, setHeld] = useState({});

  const down = (key, e) => {
    e.preventDefault();
    setHeld(p => ({ ...p, [key]: true }));
    onPress(key);
  };
  const up = (key) => {
    setHeld(p => ({ ...p, [key]: false }));
    onRelease(key);
  };

  return (
    <div className={styles.dpad}>
      {DIRS.map(({ key, cls, icon }) => (
        <div
          key={key}
          className={`${styles.btn} ${styles[cls]} ${held[key] ? styles.held : ''} ${cls === 'center' ? styles.stop : ''}`}
          onMouseDown={(e) => down(key, e)}
          onMouseUp={() => up(key)}
          onMouseLeave={() => held[key] && up(key)}
          onTouchStart={(e) => down(key, e)}
          onTouchEnd={() => up(key)}
        >
          {icon}
        </div>
      ))}
    </div>
  );
}
